export default __webpack_public_path__ + "static/media/first.1154acee.png";